import React from "react";
import PropTypes from "prop-types";
import { Layout } from "rhombus-react";

import { REDDIT_PLACEMENT_TABS } from "./Tabs";

import "./RedditSocialTabSelector.css";

export default function RedditSocialTabSelector(props) {
	const { selectedTab, onTabChange } = props;

	return (
		<div className="reddit-social-tab-container">
			<Layout.Tabs
				tabs={REDDIT_PLACEMENT_TABS}
				onTabChange={onTabChange}
				selectedTab={selectedTab}
				className="social-preview-tabs reddit-placement-tabs"
			/>
		</div>
	);
}

RedditSocialTabSelector.displayName = "RedditSocialTabSelector";

RedditSocialTabSelector.propTypes = {
	selectedTab: PropTypes.shape({
		label: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
	}).isRequired,
	onTabChange: PropTypes.func.isRequired,
};
